import React from "react";

function HandTool(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0492 23.5C9.54922 23.5 9.08255 23.3875 8.64922 23.1625C8.21589 22.9375 7.85755 22.6167 7.57422 22.2L1.19922 12.875L1.79922 12.3C2.11589 11.9833 2.49089 11.8 2.92422 11.75C3.35755 11.7 3.74922 11.8 4.09922 12.05L6.99922 14.075V4.5C6.99922 4.21667 7.09505 3.97917 7.28672 3.7875C7.47839 3.59583 7.71589 3.5 7.99922 3.5C8.28255 3.5 8.52005 3.59583 8.71172 3.7875C8.90339 3.97917 8.99922 4.21667 8.99922 4.5V17.925L5.29922 15.325L9.22422 21.05C9.30755 21.1833 9.42422 21.2917 9.57422 21.375C9.72422 21.4583 9.88255 21.5 10.0492 21.5H16.9992C17.5492 21.5 18.0201 21.3042 18.4117 20.9125C18.8034 20.5208 18.9992 20.05 18.9992 19.5V5.5C18.9992 5.21667 19.0951 4.97917 19.2867 4.7875C19.4784 4.59583 19.7159 4.5 19.9992 4.5C20.2826 4.5 20.5201 4.59583 20.7117 4.7875C20.9034 4.97917 20.9992 5.21667 20.9992 5.5V19.5C20.9992 20.6 20.6076 21.5417 19.8242 22.325C19.0409 23.1083 18.0992 23.5 16.9992 23.5H10.0492ZM10.9992 12.5V2.5C10.9992 2.21667 11.0951 1.97917 11.2867 1.7875C11.4784 1.59583 11.7159 1.5 11.9992 1.5C12.2826 1.5 12.5201 1.59583 12.7117 1.7875C12.9034 1.97917 12.9992 2.21667 12.9992 2.5V12.5H10.9992ZM14.9992 12.5V3.5C14.9992 3.21667 15.0951 2.97917 15.2867 2.7875C15.4784 2.59583 15.7159 2.5 15.9992 2.5C16.2826 2.5 16.5201 2.59583 16.7117 2.7875C16.9034 2.97917 16.9992 3.21667 16.9992 3.5V12.5H14.9992Z"
        fill="#E8EAED"
      />
    </svg>
  );
}

export default HandTool;
